module.exports = __webpack_public_path__ + "img/ring_r_c_null_1.c482237c.png";